import storageSession from "redux-persist/lib/storage/session";
import { PersistConfig } from "redux-persist";

const persistConfig: PersistConfig<any> = {
  key: "root",
  version: 1,
  storage: storageSession,
};

export default persistConfig;
